import * as Dialog from '@radix-ui/react-dialog';
import { type ForwardedRef, forwardRef } from 'react';

import { getClassNameOverride } from '~/chords/getClassNameOverride';

import type { SlideOutCloseProps } from '../types';

export const SlideOutClose = forwardRef<HTMLButtonElement, SlideOutCloseProps>(
  (
    { children, ...props }: SlideOutCloseProps,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    const className = getClassNameOverride(props, 'SlideOut.Close');

    return (
      <Dialog.Close ref={ref} {...props} className={className} asChild>
        {children}
      </Dialog.Close>
    );
  },
);

SlideOutClose.displayName = 'SlideOut.Close';
